<template>
    <tr class="TableRow">
        <td class="HTOrderCode">
            <small>{{ this.risorse["NumeroOrdine"] }}</small>
            <a href="javascript:void(0)" @click="this.showModalOrderDetails()"><span>{{ this.ordine.NumeroOrdine }}</span> <i>Order details</i></a>
        </td>
        <td class="HTOrderDate">
            <small>{{ this.risorse["DataOrdine"] }}</small>
            <span>{{ this.ordine.DataOrdine}}</span>
        </td>
        <td class="HTShippingAddress">
            <small>{{ this.risorse["IndirizzoDestinazione"] }}</small>
            <span>{{ this.ordine.IndirizzoSpedizione}}</span>
        </td>
        <td class="HTBillingData">
            <small>{{ this.risorse["IndirizzoFatturazione"] }}</small>
            <span>{{ this.ordine.IndirizzoFatturazione }}</span>
        </td>
        <td class="HTTotal">
            <small>{{ this.risorse["TotaleOrdine"] }}</small>
            <span>{{this.simboloValuta}} {{ this.formatNumber(this.ordine.PrezzoTotale, 2, ',', '.')}}</span>
        </td>
        <td class="HTAddToBasket">
            <small>{{ this.risorse["ProdottiNonDisponibili"] }}</small>
            <div class="Button Small CustomColor Iconed AddShop"><a href="javascript:void(0)" @click="this.addOrdineCarrello()">{{ this.risorse["AggiungiCarrello"] }}</a></div>
        </td>
    </tr>
    <ModalOrder v-model="this.showModal" :order="this.ordine" ></ModalOrder>
    <Modalcart v-model="this.showModalCart" :response="this.responseCart" ></Modalcart>
</template>

<script>
import {priceMixin, valutaMixin, risorseMixin} from "@/mixin.js";
import ModalOrder from "@/components/modals/ModalOrder.vue";
import OrderHistoryService from "@/services/orderHistory.service.js";
import CartService from "@/services/cart.service.js";
import Modalcart from "@/components/modals/Modalcart.vue";
import AddCartResponse from '@/models/AddCartResponse.model.js';

export default {
    name: "HistoryTableRow",
    props:{
        ordine: Object
    },
    data(){
        return {
            showModal: false,
            showModalCart: false,
            responseCart: 1
        }
    },
    mixins: [priceMixin, valutaMixin, risorseMixin],
    components:{
        ModalOrder,
        Modalcart,
    },
    methods:{
        showModalOrderDetails: function(){
            this.showModal = true;
        },
        addOrdineCarrello: function(){
            OrderHistoryService.GetRigheByOrdine(this.$store.getters.getToken, this.ordine.NumeroOrdine).then(
                (data) => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else{
                        data.forEach(element => {

                            if(element.Disponibilita > 0 && element.Catalogo){
                                this.$store.commit('updateRow', {
                                CodiceArticolo: element.CodiceArticolo, 
                                Quantita: element.Quantita, 
                                PrezzoNetto: element.PrezzoNetto, 
                                PrezzoListino: element.PrezzoListino,
                                Sconto1: 0,
                                Sconto2: 0,
                                Sconto3: 0,
                                Sconto4: 0,
                                Sconto5: 0,
                                ValoreSconto1: 0,
                                ValoreSconto2: 0,
                                ValoreSconto3: 0,
                                ValoreSconto4: 0,
                                ValoreSconto5: 0,
                                Catalogo: element.Catalogo,
                                DescrizioneArticolo: element.DescrizioneArticolo,
                                DescrizioneTaglia: element.DescrizioneTaglia,
                                DescrizioneColore: element.DescrizioneColore,
                                UrlImmagine: element.UrlImmagine,
                                Valuta: this.codiceValuta
                                });
                            }
                        });
                        this.$store.dispatch({
                                type: 'setCarrello',
                                token: this.$store.getters.getToken  
                            }).then(
                                (data) => {
                                    if(data){
                                        CartService.getCartByUsername(this.$store.getters.getToken).then(
                                            (data) => {
                                                if(data){
                                                    let responseCart = new AddCartResponse();
                                                    Object.assign(responseCart, data);
                                                    if(responseCart.Status == 1){
                                                        this.$store.commit('resetCarrelloTmp');
                                                        this.$store.commit('updateCarrello', responseCart.Carrello);
                                                        this.$store.commit('setChkSeasonalOrders',(responseCart.Carrello?.ChkSeasonalOrder ?? false));
                                                    }
                                                    this.showModalCart = true;
                                                }else{
                                                    this.showModalCart = true; 
                                                    this.showModalCart = -1;
                                                }
                                            }
                                        );
                                    }
                                    else{
                                        this.showModalCart = true; 
                                        this.showModalCart = -1;
                                    }
                                }
                            );
                    }
                }
            ).catch(
                (err) => {console.log(err)}
            );
        }
    },
}
</script>